import script from "./BoosterCcsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./BoosterCcsWidget.vue?vue&type=script&setup=true&lang=js"

import "./BoosterCcsWidget.vue?vue&type=style&index=0&id=59649374&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59649374"]])

export default __exports__